// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__46TxX","iconWithCounter":"styles_iconWithCounter__mr8dS","counterForLabel":"styles_counterForLabel___A3nI","counterForIcon":"styles_counterForIcon__qX_vO"};